import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createTextVNode as _createTextVNode, withCtx as _withCtx, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "queue-container"
}
const _hoisted_2 = { class: "queue-header" }
const _hoisted_3 = { class: "queue-items" }
const _hoisted_4 = { class: "min-w-0" }
const _hoisted_5 = { class: "text-sm" }
const _hoisted_6 = { class: "text-xs text-muted-foreground mt-1" }

import { Badge } from '@/components/ui/badge';
import { Clock3 } from '@lucide/vue';

import moment from 'moment';
import { getUserFullNameWithLoginName } from '../models/saas_extension';

interface Props {
  queue: Queue[];
}


export default /*@__PURE__*/_defineComponent({
  __name: 'ConnectionQueue',
  props: {
    queue: {}
  },
  setup(__props: any) {



function getUserFullNameWithAccName(user: any): string {
  return getUserFullNameWithLoginName(user);
}

function formatDateTime(dateTime: string): string {
  return moment(dateTime).format('DD.MM.YYYY HH:mm');
}

return (_ctx: any,_cache: any) => {
  return (__props.queue !== null && __props.queue.length > 0)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createVNode(_unref(Clock3), { size: 14 }),
          _createElementVNode("span", null, "Очередь (" + _toDisplayString(__props.queue.length) + ")", 1)
        ]),
        _createElementVNode("ol", _hoisted_3, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.queue, (queueItem, index) => {
            return (_openBlock(), _createElementBlock("li", {
              key: queueItem.id,
              class: "queue-item"
            }, [
              _createVNode(_unref(Badge), {
                variant: "outline",
                class: "queue-position"
              }, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(index + 1), 1)
                ]),
                _: 2
              }, 1024),
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, _toDisplayString(getUserFullNameWithAccName(queueItem.user)), 1),
                _createElementVNode("div", _hoisted_6, _toDisplayString(formatDateTime(queueItem.date_created)), 1)
              ])
            ]))
          }), 128))
        ])
      ]))
    : _createCommentVNode("", true)
}
}

})